import React from 'react';
import { NotificationI } from '../../../types';
import { requestDetailsModalCall } from '../../../containers/MainWrapper/MainWrapper';
import { observer } from 'mobx-react';

interface NotificationApprovalPropsI {
  message: NotificationI,
  deleteNotif: (msgId: number) => void,
  onClose: () => void,
}

export const NotificationApproval = observer((props: NotificationApprovalPropsI) => {
  const {message, onClose ,  deleteNotif} = props;
  return <div className={'notification_item'}><b>{message.authorName}</b> has submitted a leave <span
    onClick={()=>{
      onClose();
      deleteNotif(message.id);
      requestDetailsModalCall.showImmediately({id: message.leaveRequestId });
    }}>request for approval</span>.</div>;
});